export const RETRIEVE_HISTORY = 'RETRIEVE_HISTORY';
export const DUPLICATE_HISTORY = 'DUPLICATE_HISTORY';
export const DESTROY_HISTORY = 'DESTROY_HISTORY';



// WEBPACK FOOTER //
// ./src/components/History/historyActionTypes.js